import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FLORAFAUNA_FORM, IMPORTEXPORT_FORM} from '../constants';
const applicationsMapping = {
    'flora-fauna': FLORAFAUNA_FORM,
    'import-export': IMPORTEXPORT_FORM
  };
  
export const RedirectIfCaptchaNotSelected = (props) => {
  const captcha = useSelector((state) => state.captcha);
  const initialPageUrl = window.location.pathname.split('/').filter((i) => i)[0];
  const form = useSelector((state) => state.form);

  useEffect(() => {
    
    if (process.env.REACT_APP_CAPTCHA_ENABLED === 'false') {
      return;
    }
    
    if (applicationsMapping[form.form] && !captcha[applicationsMapping[initialPageUrl]] && form.redirectTo === null) {
      console.log('recapcha ' + form.form);
      props.history.push(`/${initialPageUrl}`);
    }
  });
};

export const RedirectIfAllSectionAreNotCompleted = (props) => {
  const applicantDetails = useSelector((state) => state.personalDetails);
  const qualifications = useSelector((state) => state.qualificationDetail);
  const organisationDetails = useSelector((state) => state.organisationDetail);
  const projectDetails = useSelector((state) => state.projectDetail);
  const locationDetail = useSelector((state) => state.locationDetail);
  const focusOfWorkDetail = useSelector((state) => state.focusOfWorkDetail);
  const associates = useSelector((state) => state.associateDetail);
  const documents = useSelector((state) => state.documentDetail);
  const initialPageUrl = window.location.pathname.split('/').filter((i) => i)[0];

  const sectionCompleted =
    applicantDetails.finished ||
    qualifications.finished ||
    associates.finished ||
    focusOfWorkDetail.finished ||
    organisationDetails.finished ||
    locationDetail.finished ||
    projectDetails.finished ||
    documents.finished;

    useEffect(() => {
      if (!sectionCompleted) {
        props.history.push(`/${initialPageUrl}/dashboard`);
      }
    });
  
};